import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ISelectIngredients, ISelectIngredientsScreen } from './types';
import { RequestStatus } from '@app/constants';
import { IRequestFailed } from '@app/types';

const initialState: ISelectIngredientsScreen = {
  selectedIngredients: {},
};

const slice = createSlice({
  name: 'selectIngredientsSlice',
  initialState,
  reducers: {
    selectedIngredients: (state, action: PayloadAction<ISelectIngredients>) => {
      state.selectedIngredients.status = RequestStatus.RUNNING;
    },
    selectedIngredientsSuccess(state) {
      state.selectedIngredients.status = RequestStatus.SUCCESS;
    },
    selectedIngredientsFailed(state, action: PayloadAction<IRequestFailed>) {
      state.selectedIngredients.status = RequestStatus.ERROR;
    },
  },
});

export default slice.reducer;

export const { selectedIngredients, selectedIngredientsSuccess, selectedIngredientsFailed } =
  slice.actions;
